module.exports = __webpack_public_path__ + "media/icons/arrow-right-6b119bf8eb3a4fcb22f74440fa86df77.svg";